<svg style="display:none" xmlns="http://www.w3.org/2000/svg">
  <symbol id="_svg-delete" viewBox="0 0 24 24">
    <path d="M19,4h-2h-2c0-0.6-0.4-1-1-1H9C8.4,3,8,3.5,8,4H6H4C3.4,4,3,4.5,3,5c0,0.6,0.4,1,1,1v14
            c0,1.1,0.9,2,2,2h11c1.1,0,2-0.9,2-2V6c0.6,0,1-0.4,1-1C20,4.5,19.6,4,19,4z M17,20H6V6h11V20z M11.5,17c0.3,0,0.5-0.2,0.5-0.5v-7
            C12,9.2,11.8,9,11.5,9C11.2,9,11,9.2,11,9.5v7C11,16.8,11.2,17,11.5,17z M14.5,17c0.3,0,0.5-0.2,0.5-0.5v-7C15,9.2,14.8,9,14.5,9
            C14.2,9,14,9.2,14,9.5v7C14,16.8,14.2,17,14.5,17z M8.5,17C8.8,17,9,16.8,9,16.5v-7C9,9.2,8.8,9,8.5,9C8.2,9,8,9.2,8,9.5v7
            C8,16.8,8.2,17,8.5,17z" />
  </symbol>
  <symbol id="_svg-close" viewBox="0 0 24 24">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
  </symbol>
  <symbol id="_svg-file-download" viewBox="0 0 24 24">
    <path d="M19,9h-4V3H9v6H5l7,7L19,9z M5,18v2h14v-2H5z" />
  </symbol>
  <symbol id="_svg-file-upload" viewBox="0 0 24 24">
    <polygon points="9,16 15,16 15,10 19,10 12,3 5,10 9,10 " />
    <rect x="5" y="18" width="14" height="2" />
  </symbol>
  <symbol id="_svg-refresh" viewBox="0 0 24 24">
    <path d="M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z "></path>
  </symbol>
  <symbol id="_svg-priority" viewBox="0 0 24 24">
    <path d="M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z" />
  </symbol>
  <symbol id="_svg-type-icon" viewBox="0 0 24 24">
    <path d="M14.74,24h4.92a2.17,2.17,0,0,0,2.12-2.11V7.1l-7-7H4.17A2.17,2.17,0,0,0,2.06,2.17V21.89A2.17,2.17,0,0,0,4.17,24H14.74ZM4.88,21.18V2.88h8.45V7.1a1.51,1.51,0,0,0,1.41,1.41H19V21.18Z"/>
    <path d="M13.19,19.37H10.66v-7.3H8.37V10h7.1v2.07H13.19Z"/>
  </symbol>
  <symbol id="_svg-search" viewBox="0 0 24 24">
    <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
  </symbol>
</svg>

<div [hidden]="!initializing"><img class="loading-spinner" src="//lfxstatic.com/img/general/loading-spinner.gif" alt="loading..."></div>
<div *ngIf="!print">
  <div *ngIf="!initializing" class="docorg-shell">
    <lf-message-toast class="toast-messages" [messages]="toastMessages"></lf-message-toast>
    <app-organizer-toolbar
        [docTotal]="documentCount"
        [types]="typeViewModel"
        [isReadonly]="readOnly || initError != 'NONE'"
        [isDisabled]="disabled"
        [allowDownload]="allowDownload"
        [importMode]="importMode"
        [selectedDocs]="fileEntries"
        (onImport)="openImportPickerDialog($event)"
        (typeChange)="onTypeChange($event)"
        (deleteFile)="onDeleteSelectedDoc()"
        (downloadFile)="onDownloadSelectedDoc()"
        (refreshFileset)="onRefreshFileset()"></app-organizer-toolbar>
    <app-organizer-table 
        [tabindex]="readOnly ? -1 : 0"
        [isReadonly]="shouldDisableTable()"
        [initError]="initError"
        [docResources]="fileEntries" 
        [docColumns]="displayColumns" 
        [docStatuses]="statusViewModel" 
        [docTypes]="typeViewModel"
        [repoName]="repoName"
        [waBaseURL]="waBaseURL"
        [errors]="validatorService.errors"
        [requiredStatus]="requiredStatusInfo"
        [width]="width"
        [maxHeight]="maxHeight"
        [importMode]="importMode"
        [showErrors]="highlightErrors"
        [parentFieldId]="parentFieldId"
        (validate)="onValidate($event)"
        (onImport)="openImportPickerDialog($event)"
        (onModelChange)="onTableModelChanged()"></app-organizer-table>
  </div>
  <a id="downloadFile" hidden></a>
  <fileset-error-messages *ngIf="showErrors" 
    [initError]="initError"
    [errors]="validatorService.errors"
    [requiredStatus]="requiredStatusInfo"></fileset-error-messages>
</div>
<div *ngIf="print && !initializing">
  <fileset-print
      [docResources]="fileEntries"
      [docTypes]="typeViewModel"
      [docStatuses]="statusViewModel"
      [docColumns]="displayColumns"
      [initError]="initError"
      [width]="width"></fileset-print>
</div>

<!-- <div>
  <button type="button" (click)="saveInstance()">save</button>
</div> -->
